import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import {
  countUnitField,
  factoryIdField,
  factoryCountField,
} from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import {
  currencyField,
  currencyQuantityField,
} from './common/expenditureFields';

export const tier1FactoriesSpendMetadata = {
  displayName: msg({
    message: 'Supplier factories expenses: Tier 1',
    context:
      'Activity data schema name for supplier factories expenses: Tier 1',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    currency: currencyField,
    currency_quantity: currencyQuantityField,
    // NOTE: quantity does not exist on the BAT but currency_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: currencyQuantityField,
    factory_id: factoryIdField,
    industry: {
      displayName: msg({
        message: 'Industry',
        context: 'Industry of the Tier 1 factory.',
      }),
    },
    order_quantity: factoryCountField,
    order_unit: countUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
